import { useQuery } from "@tanstack/react-query";
import { SourcePartnerProductMappingModel } from "api/client.generated";
import useApi from "../useApi";

interface UseSourcePartnerProductMappingsReturn {
  productMappings: SourcePartnerProductMappingModel[] | undefined;
  isProductMappingsFetching: boolean;
}

const useSourcePartnerProductMappings = (): UseSourcePartnerProductMappingsReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getSourcePartnerProductMappings"],
    queryFn: () => partnersMigrationClient.getSourcePartnerProductMappings(),
  });

  return { productMappings: data, isProductMappingsFetching: isFetching };
};

export default useSourcePartnerProductMappings;
